import React, { Component } from 'react'

const linkStyle = {
  fontSize: '14px',
  textDecoration: 'underline'
}

export class Missing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showItem: false,
      showChildren: props.item && props.item.pageKey
    }
  }

  toggleItem = (ev) => {
    ev.preventDefault()
    this.setState({ showItem: !this.state.showItem })
  }

  toggleChildren = (ev) => {
    ev.preventDefault()
    this.setState({ showChildren: !this.state.showChildren })
  }

  render() {
    const { item, children } = this.props
    const { items, ...restItem } = item
    return (
      <div
        style={{
          border: '2px dashed #f0f0f0',
          backgroundColor: '#fdfdfd',
          margin: '16px 16px'
        }}
      >
        <div
          style={{
            margin: '16px'
          }}
        >
          <h4
            style={{
              fontFamily: 'monospace',
              fontSize: '16px',
              margin: '16px 0'
            }}
          >
            {item.type} / {item.layoutVariant}
          </h4>
          <div>
            <div>
              <a onClick={this.toggleItem} role="button" tabIndex="0">
                <div style={linkStyle}>{this.state.showItem ? 'hide item' : 'show item'}</div>
              </a>
              <pre style={{ display: this.state.showItem ? 'block' : 'none', whiteSpace: 'pre-wrap' }}>{JSON.stringify(restItem, null, 2)}</pre>
              <pre style={{ display: this.state.showItem ? 'none' : 'block' }}>&#123; ... &#125;</pre>
            </div>
          </div>
          {children && (
            <div>
              <a onClick={this.toggleChildren} role="button" tabIndex="0">
                <div style={linkStyle}>{this.state.showChildren ? `hide children (${children.length})` : `show children (${children.length})`}</div>
              </a>
              <div
                style={{
                  display: this.state.showChildren ? 'block' : 'none',
                  margin: '16px 0'
                }}
              >
                {children}
              </div>
              <pre style={{ display: this.state.showChildren ? 'none' : 'block' }}>[ ... ]</pre>
            </div>
          )}
        </div>
      </div>
    )
  }
}
